import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Section from '../../common/Section';
import TextBlockWithIcon from '../textBlock/TextBlockWithIcon';
import Anchor from '../utils/Anchor';

const Wrapper = styled(Section)`
  padding-top: ${props => props.paddingTop || 'var(--default-vertical-padding)'};
  padding-bottom: ${props => props.paddingBottom || 'var(--default-vertical-padding)'};
  padding-left: ${props => props.paddingLeft || 'var(--default-horizontal-padding)'};
  padding-right: ${props => props.paddingRight || 'var(--default-horizontal-padding)'};
  background-color: ${props => props.backgroundColor || 'inherit'};
  border-radius: ${props => props.borderRadius || 0};
`;

const OneColumnBlock = ({ content }) => {
  const {
    title,
    blockId,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    backgroundColor,
    borderRadius,
  } = content;
  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Wrapper
        paddingTop={paddingTop}
        paddingBottom={paddingBottom}
        paddingLeft={paddingLeft}
        paddingRight={paddingRight}
        backgroundColor={backgroundColor}
        borderRadius={borderRadius}
      >
        <TextBlockWithIcon
          content={{ ...content, paddingTop: 0, paddingBottom: 0 }}
          srcBlockName={`General Text Block - ${title}`}
        />
      </Wrapper>
    </React.Fragment>
  );
};

OneColumnBlock.propTypes = {
  content: PropTypes.object,
};

export default OneColumnBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/columnBlock/OneColumnBlock.js